import React, { useState } from "react";
import "./DeleteRepModal.css"; // Reuse same styles
import StandardModal from "../shared/Modal/StandardModal";
import { useAuth } from "../../context/AuthContext";
import { getApiEndpoint } from "../../config/config";
import DisplayMessage from "../shared/DisplayMessage/DisplayMessage";

function DeactivateRepModal({ isOpen, onClose, rep, onConfirmDeactivate }) {
  const { getVerifiedJWT } = useAuth();
  const [isDeactivating, setIsDeactivating] = useState(false);
  const [error, setError] = useState(null);
  const [reason, setReason] = useState("");

  const handleDeactivate = async () => {
    if (!rep || isDeactivating || !reason.trim()) {
      setError("Please provide a reason for deactivation");
      return;
    }

    try {
      setIsDeactivating(true);
      setError(null);

      const jwt = await getVerifiedJWT();
      if (!jwt) {
        setError("Authentication failed");
        return;
      }

      const response = await fetch(
        getApiEndpoint(`/v1/rep/rep/${rep.rep_id}/deactivate`),
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwt}`,
          },
          body: JSON.stringify({
            reason: reason.trim(),
          }),
        }
      );

      if (response.ok) {
        if (onConfirmDeactivate) {
          onConfirmDeactivate();
        }
        onClose();
        setReason("");
      } else {
        const errorData = await response.json().catch(() => ({}));
        setError(errorData.message || "Failed to deactivate rep");
      }
    } catch (err) {
      setError("Failed to deactivate rep");
    } finally {
      setIsDeactivating(false);
    }
  };

  const handleClose = () => {
    setReason("");
    setError(null);
    onClose();
  };

  if (!rep) return null;

  return (
    <StandardModal
      isOpen={isOpen}
      onClose={handleClose}
      title="Deactivate Representative"
      footerCenter={
        <>
          <button
            className="btn btn-md btn-secondary"
            onClick={handleClose}
            disabled={isDeactivating}
            style={{ marginRight: "8px" }}
          >
            Cancel
          </button>
          <button
            className="btn btn-md btn-danger"
            onClick={handleDeactivate}
            disabled={isDeactivating || !reason.trim()}
          >
            {isDeactivating ? "Deactivating..." : "Deactivate Rep"}
          </button>
        </>
      }
    >
      <div>
        <div className="delete-rep-modal-confirmation-message">
          <p>You are about to deactivate:</p>
          <div className="delete-rep-modal-rep-name">
            {rep.first_name} {rep.last_name}
          </div>
          <p style={{ marginTop: "16px", marginBottom: "8px" }}>
            This will move them to your "Dropped Off Reps" list on the
            recruiting page.
          </p>
          <p
            style={{ marginBottom: "16px", fontSize: "14px", color: "#6b7280" }}
          >
            You can reactivate them later if needed.
          </p>

          <div style={{ marginTop: "20px" }}>
            <label
              style={{
                display: "block",
                marginBottom: "8px",
                fontWeight: "600",
              }}
            >
              Reason for deactivation:{" "}
              <span style={{ color: "#dc2626" }}>*</span>
            </label>
            <textarea
              value={reason}
              onChange={e => setReason(e.target.value)}
              placeholder="e.g., Left company, Moved to another state, Performance issues..."
              rows={4}
              disabled={isDeactivating}
              style={{
                width: "100%",
                padding: "8px 12px",
                border: "1px solid #e5e7eb",
                borderRadius: "6px",
                fontSize: "14px",
                resize: "vertical",
              }}
            />
          </div>

          {error && <DisplayMessage type="error" message={error} />}
        </div>
      </div>
    </StandardModal>
  );
}

export default DeactivateRepModal;
